<script>
  import Icon from './Icon.svelte';
  import {
    notificationState,
    dismissNotification,
    runNotificationAction,
  } from '../os/notifications.svelte.js';
</script>

<aside class="notification-center" aria-label="Notifications" aria-live="polite">
  {#each notificationState.items as item (item.id)}
    <section class="notification">
      <div class="notification-icon"><Icon name={item.icon} size={32} /></div>
      <div class="notification-copy">
        <strong>{item.title}</strong>
        <p>{item.message}</p>
        {#if item.actionLabel}
          <button class="notification-action" onclick={() => runNotificationAction(item)}>
            {item.actionLabel}
          </button>
        {/if}
      </div>
      <button
        class="notification-close"
        aria-label="Dismiss notification"
        onclick={() => dismissNotification(item.id)}
      >×</button>
    </section>
  {/each}
</aside>

<style>
  .notification-center {
    position: fixed;
    top: 30px;
    right: 10px;
    z-index: 50000;
    width: min(330px, calc(100vw - 20px));
    display: grid;
    gap: 8px;
    pointer-events: none;
  }

  .notification {
    pointer-events: auto;
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr) 20px;
    gap: 10px;
    padding: 10px;
    color: #f5f5f5;
    background: rgba(24, 26, 27, 0.94);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 7px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(16px);
    animation: notification-in 180ms ease-out;
  }

  .notification-icon {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
  }

  .notification-copy { min-width: 0; }
  .notification-copy strong { font-size: 13px; }
  .notification-copy p {
    margin: 3px 0 0;
    color: #c8c8c8;
    font-size: 12px;
    line-height: 1.35;
  }

  .notification-action,
  .notification-close {
    border: 0;
    color: #7eb7ff;
    background: none;
    cursor: pointer;
  }

  .notification-action {
    padding: 5px 0 0;
    font-size: 12px;
  }

  .notification-close {
    align-self: start;
    color: #aaa;
    font-size: 17px;
    line-height: 1;
  }

  @keyframes notification-in {
    from { opacity: 0; transform: translateY(-8px); }
  }
</style>
